import { CalendarRange } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconCalendarRange(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <CalendarRange />
    </IconWrapper>
  );
}
